import React from "react";
import { RequestDetailHeader } from "components/DesignSystem/RequestDetailHeader";

export const toSelectedEmployeeHeaderDetails = (selectedUser) => {
  if (!selectedUser || typeof selectedUser !== "object") return null;

  return {
    image_url: selectedUser?.image_url,
    employee_id:
      selectedUser?.employee_id ||
      selectedUser?.employee_code ||
      selectedUser?.emp_id,
    user_name:
      selectedUser?.label ||
      selectedUser?.user_name ||
      selectedUser?.employee_name,
    department_name:
      selectedUser?.department_name || selectedUser?.department,
    designation:
      selectedUser?.designation_name ||
      selectedUser?.designation ||
      selectedUser?.type,
  };
};

export const SelectedEmployeeHeader = ({ selectedUser }) => {
  const userDetails = toSelectedEmployeeHeaderDetails(selectedUser);
  if (!userDetails) return null;

  return <RequestDetailHeader userDetails={userDetails} />;
};

export default SelectedEmployeeHeader;
